import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TitleUpdater = () => {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname;
        let title = 'Collaboration World';

        switch (path) {
            case '/':
                title = 'Collaboration World - Home';
                break;
            case '/about':
                title = 'Collaboration World - About Us';
                break;
            case '/services':
                title = 'Collaboration World - Services';
                break;
            case '/contact':
                title = 'Collaboration World - Contact';
                break;
            case '/login':
                title = 'Collaboration World - Login';
                break;
            case '/register':
                title = 'Collaboration World - Register';
                break;
            case '/dashboard':
                title = 'Collaboration World - Dashboard';
                break;
            case '/profile':
                title = 'Collaboration World - Profile';
                break;
            case '/kyc-verification':
                title = 'Collaboration World - KYC Verification';
                break;
            default:
                title = 'Page Not Found - Collaboration World';
        }

        document.title = title;
    }, [location]);

    return null;
};

export default TitleUpdater;
